import React from 'react';
// import Lottie from 'react-lottie';
import './Id_Proof_Lottie.css';
import * as animationData from './Id_Proof_Lottie.json';
import Lottie from 'lottie-react';

function Id_Proof_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Id_Proof_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Id_Proof_Lottie;